<template>
  <div>
    <!-- 标题 -->
    <h3 v-if="title">{{ title }}</h3>
    <h3 v-if="titleSecond">{{ titleSecond }}</h3>
    <h1 class="timeClass" v-if="nowTimeT">{{ nowTimeT }}</h1>


    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%" v-if="filters && filters.length > 0">
      <Collapse style="width: 100%" v-model="value1">
        <Panel style="width: 100%" name="1">
          展开搜索条件
          <Form ref="formQuery" :label-width="100" :label-position="left" :label-colon="true" :model="query" style="
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              flex-wrap: wrap;
              width: 85%;
              margin-top: 10px;
            " slot="content">
            <Col span="3" :xxl="6" :xl="4" :lg="6" :md="8" :sm="12" :xs="24" style="
                display: flex;
                flex-direction: row-reverse;
                position: absolute;
                right: 20px;
              ">
            <Button icon="ios-search" type="info" @click="search" style="width: 90px">搜索
            </Button>
            <Button icon="ios-close-circle" type="error" @click="clearFilter" style="width: 90px; margin-right: 15px">
              重置
            </Button>
            </Col>
            <template v-for="(v, k) in filters">
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24" v-if="v.type === 'inputs'"
                style="margin: 0px 0 10px 0; float: right; display: flex">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <div style="margin-bottom: 0; display: flex">
                  <Input :key="k" :placeholder="'最小' + v.label" clearable v-model="query[v.name1]"></Input>
                  <div>~</div>
                  <Input :key="k" :placeholder="'最大' + v.label" clearable v-model="query[v.name2]"></Input>
                </div>
              </FormItem>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24" v-if="v.type === 'string' || v.type === 'text' || v.type === 'input'
                " style="margin: 0px 0 10px 0; float: right; display: flex">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <Input :key="k" :placeholder="v.label" clearable v-model="query[v.name]"
                  @keyup.enter.native="v.KeyEnter"></Input>
              </FormItem>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24" v-else-if="v.type === 'select'"
                style="margin: 0px 0 10px 0; float: right">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <i-select :key="k" v-model="query[v.name]" clearable style="width: 190px" @keyup.enter.native="v.KeyEnter"
                  :multiple="v.multiple ? true : false" :disabled="v.disabled ? true : false" :placeholder="v.label"
                  :filterable="true" @on-change="v.onChange">
                  <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk">{{ s.name }}
                  </Option>
                </i-select>
              </FormItem>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24"
                v-else-if="v.type === 'selectsearch'" style="margin: 0px 0 10px 0; float: right">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <i-select :key="k" v-model="query[v.name]" clearable remote filterable @keyup.enter.native="v.KeyEnter"
                  :remote-method="v.remoteMethod" style="width: 190px" :multiple="v.multiple ? true : false"
                  :disabled="v.disabled ? true : false" :placeholder="v.label" @on-change="v.onChange">
                  <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk">{{ s.name }}
                  </Option>
                </i-select>
              </FormItem>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24"
                v-else-if="v.type === 'datetimerange'" style="margin: 0px 0 10px 0; float: right">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <DatePicker clearable :key="k" type="daterange" v-model="query1[v.name + v.lable]" style="width: 190px"
                  @keyup.enter.native="v.KeyEnter" format="yyyy-MM-dd" placeholder="选择时间" :options="optionsData"
                  @on-change="(val) => {
                    timeDateChange(val, v.name);
                  }
                    "></DatePicker>
              </FormItem>
              </Col>
              <Col :key="k" v-else-if="v.type === 'distpicker'" style="margin: 0px 0 10px 0; float: right">
              <FormAddress @on-change="(val) => {
                onAddressChange(val, v.name);
              }
                " style="width: 100%"></FormAddress>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24"
                v-else-if="v.type === 'addressInfo'" style="width: auto; margin: 0px 0 10px 0; float: right">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <v-distpicker :disabeld="disabeld" type="addressInfo" :province="province" :city="city" :area="area"
                  @selected="v.onSelect"></v-distpicker>
              </FormItem>
              </Col>
            </template>
          </Form>
        </Panel>
      </Collapse>
    </Row>
    <!-- 操作 -->
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%" v-if="actions && actions.length > 0">
      <div v-for="(v, k) in actions" :key="k" style="margin-right: 10px; display: inline-flex">
        <Button :size="v.size || 'default'" :type="v.type || 'warning'" v-auth="v.auth" :icon="v.icon || ''"
          @click="v.onClick">{{ v.label }}
        </Button>
      </div>
    </Row>
    <!-- 表格 -->
    <Table ref="tablelist" :columns="tableCols" style="margin-top: 20px" :footer="table.footer" :data="data2">
      <template #handle="{ row, index }">
        <Button type="default" size="small" style="marginRight: '5px';border:none;color: #4991ff;"
          v-show="row.state == null ? true : false" @click="toAdd(row)">发起转运</Button>
        <Button type="default" size="small" style="marginRight: '5px';border:none;color: #4991ff;"
          v-show="row.state == null ? true : false" @click="toEdit(row)">编辑</Button>
        <Button type="default" size="small" style="marginRight: '5px';border:none;color: #4991ff;"
          @click="toDelete(row)">删除</Button>
      </template>

      <div slot="footer" style="display: flex; justify-content: center">
        <Page :total="total" show-total show-sizer show-elevator :page-size="pageSize" @on-change="changePageS($event)"
          @on-page-size-change="changePage($event)" :model-value="currentPage" :page-size-opts="pageSizeOpts" />
      </div>
    </Table>
    <!-- 动态组件 -->
    <component v-for="(item, index) in extRender || []" :key="index" :ref="item" :is="item"></component>
  </div>
</template>
<script>
import baseList from "@/views/components/base/baseList.vue";
import ImportTemplate from "@/views/components/common/form/patientImportTemplate.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import config from "../../../config";
import { resolveComponent } from 'vue'


export default {
  extends: baseList,
  components: {
    ImportTemplate
  },
  data() {
    return {
      nowTimeT: "",
      dingshiqi: null,
      table: {
        mname: "nursing",
        key: "id",
        url: {
          list: "/admin/system/nursing/list",
          del: "/admin/system/nursing/del",
        },
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      pageSizeOpts: [
        20,
        30,
        50,
        100,
        200,
        500
      ],
      menus: [
      ],
      query: {
      },
      actions: [
        {
          label: "导入手术名单",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "system/nursing/import",
          type: "info",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          auth: "system/nursing/download",
          type: "info",
        },
        {
          label: "新建手术人员",
          icon: "md-add",
          type: "info",
          onClick: this.toAddPatient,
          auth: "",
        },
        {
          label: "新建派单",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
        {
          label: "历史",
          type: "info",
          onClick: this.before,
          auth: "",
        },
        {
          label: "今日",
          type: "info",
          onClick: this.nowData,
          auth: "",
        },
        {
          label: "导出",
          icon: "md-download",
          onClick: this.exportDataH,
          type: "info",
          auth: "",
        },
      ],
      filters: [
        {
          label: "预计手术时间",
          KeyEnter: this.search,
          name: "",
          value: "",
          type: "datetimerange",
        },
        {
          label: "护工姓名",
          KeyEnter: this.search,
          name: "nursingName",
          value: "",
          type: "input",
        },
        {
          label: "病人姓名",
          KeyEnter: this.search,
          name: "patientName",
          value: "",
          type: "input",
        },
        {
          label: "患者所在科室",
          name: "deskName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "护送到手术间",
          name: "transferDeskName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "状态",
          name: "state",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: "1",
              name: "待接单",
            },
            {
              value: "2",
              name: "转运中",
            }, {
              value: "5",
              name: "已到达",
            },
            {
              value: "3",
              name: "已进入",
            }, {
              value: "4",
              name: "送回中",
            },
          ],
        },
      ],
      tableCols: [
        {
          title: "患者信息",
          key: "workNo",
          width: 170,
          align: "center",
          render: (h, p) => {
            return h('div', {
              style: {
                textAlign: 'left',
              }
            }, [
              h('span', {
                style: {
                  marginTop: "5px",
                },
              }, "住院号: "),
              h('span', {
                style: {
                  color: 'blue',
                  marginTop: "5px",
                },
              }, p.row.patientId),
              h('span', {
                style: {
                  marginTop: "5px",
                  display: 'inline-block',
                  width: '100%',
                  textAlign: 'left',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
                domProps: {
                  title: p.row.patientName
                }
              }, "姓名: " + p.row.patientName)
            ])
          },
        },
        {
          title: "派单信息",
          width: 200,
          align: "center",
          key: "deskName",
          tooltip: "true",
          render: (h, params) => {
            const row = params.row;
            const text = row.deskName
            return h(
              "div", {
              style: {
                textAlign: 'left',
              }
            }, [
              h('span',
                text ? "患者所在科室:" + text : ""),
              text ? h('br') : "",
              h('span',
                text ? "需护送到手术间:" + row.tranferDeskName : ""),
              text ? h('br') : "",
              h('span',
                "当前状态: "
              ),
              row.state == null ? h('span', {
                style: {
                  color: 'orange',
                },
              },
                "待派单"
              ) : "", row.state == 1 ? h('span', {
                style: {
                  color: 'orange',
                },
              },
                "待接单"
              ) : "", row.state == 2 ? h('span', {
                style: {
                  color: 'orange',
                },
              },
                "接到患者"
              ) : "", row.state == 5 ? h('span', {
                style: {
                  color: 'orange'
                }
              },
                "到达手术室"
              ) : "", row.state == 3 ? h('span', {
                style: {
                  color: 'orange',
                },
              },
                "进入手术间"
              ) : "", row.state == 4 ? h('span', {
                style: {
                  color: 'orange',
                },
              },
                "准备送回"
              ) : "",
            ]

            );
          },
        },
        {
          title: "待接单➨",
          key: "orderReceivingTime",
          minWidth: 200,
          align: "center",
          tooltip: "true",

          render: (h, params) => {
            const row = params.row;
            const text = row.orderReceivingTime
            return h(
              "div",
              {
                style: {
                  textAlign: 'left',
                }
              },
              [h('span',
                text ? "您的手术转运任务已发出!" : ""),
              text ? h('br') : "",
              h('span',
                (row.nursingName ? "护工" + row.nursingName : "")),
              h('span',
                (row.nursingPhoneNumber ? row.nursingPhoneNumber : "")),
              row.nursingName ? h('br') : "",
              h('span',
                text ? text : ""),

              ]
            );
          },
        },
        {
          title: "接到患者➨",
          key: "orderTransferTime",
          minWidth: 200,
          align: "center",
          tooltip: "true",
          render: (h, params) => {
            const row = params.row;
            const text = row.orderTransferTime
            return h(
              "div", {
              style: {
                textAlign: 'left',
              }
            }, [
              h('span',
                (text && row.nursingName) ? ("护工" + row.nursingName) : ""),
              h('span',
                (text && row.nursingPhoneNumber) ? row.nursingPhoneNumber : ""),
              text && row.nursingName ? h('br') : "",
              h('span',
                text ? "已扫码接到患者" : ""),
              text ? h('br') : "",
              h('span',
                text ? row.patientId + "(" + row.patientName + ")" + "正送往手术室!" : ""),
              text ? h('br') : "",
              h('span',
                text ? text : ""),

            ]

            );
          },
        },
        {
          title: "到达手术室➨",
          key: "deliveryPatientTime",
          minWidth: 180,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.deliveryPatientTime;
            if (text) {
              return h(
                "div", {
                style: {
                  textAlign: 'left',
                }
              }, [
                h('span',
                  row.nursingName ? "护工" + row.nursingName : ""
                ), h('span',
                  row.nursingPhoneNumber ? row.nursingPhoneNumber : ""
                ),
                row.nursingName ? h('br') : "",
                h('span',
                  text ? "扫码确认患者" + row.patientId + "(" + row.patientName + ")" : ""),
                text ? h('br') : "",
                h('span',
                  text ? "已到达手术室！" : ""),
                text ? h('br') : "",
                h('span',
                  text ? text : ""),

              ]

              );
            }

          }
        },
        {
          title: "进入手术间➨",
          key: "orderFinishTime",
          minWidth: 180,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.orderFinishTime;
            return h(
              "div", {
              style: {
                textAlign: 'left',
              }
            }, [
              h('span',
                row.sendCurIdName ? "医护" + row.sendCurIdName : ""
              ), h('span',
                row.sendCurIdPhoneNumber ? row.sendCurIdPhoneNumber : ""
              ),
              row.sendCurIdName ? h('br') : "",
              h('span',
                text ? "扫码确认患者" + row.patientId + "(" + row.patientName + ")" : ""),
              text ? h('br') : "",
              h('span',
                text ? "已到达手术间" + row.tranferDeskName : ""),
              text ? h('br') : "",
              h('span',
                text ? text : ""),

            ]

            );
          },
        },
        {
          title: "准备送回",
          width: 180,
          align: "center",
          key: "orderBackTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.orderBackTime
            return h(
              "div", {
              style: {
                textAlign: 'left',
              }
            }, [
              h('span',
                text ? "手术已结束,护工" : ""),
              text ? h('br') : "",
              h('span',
                row.backNursingName ? row.backNursingName : ""),
              h('span',
                row.backNursingPhoneNumber ? row.backNursingPhoneNumber : ""),
              row.backNursingName ? h('br') : "",
              h('span',
                text ? "扫码接到患者" + row.patientId + "(" + row.patientName + ")" : ""),
              text ? h('br') : "",
              h('span',
                text ? "准备送回科室。" : ""),
              text ? h('br') : "",
              h('span', text ? text : ""),
            ]
            );
          },
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          slot: "handle",
          fixed: "right",
        },
      ],
      data2: [

      ]
    };
  },
  created() {

    this.query.begin = new Date().toLocaleDateString()
    this.query.end = new Date().toLocaleDateString()
    this.initDatas();
    // 先执行一次,可以让页面打开是就会有显示时间
    this.dingshiqi = setInterval(() => {
      this.nowTime()
    }, 1000)

  },
  destroyed() {
    clearInterval(this.dingshiqi)
  },
  methods: {
    changePage(e) {
      // console.log(e)
      // alert(111)
      // this.query.pageSize = this.pageSize
      // this.query.pageNum = pageSize

      this.pageSize = e
      this.search()

    },
    changePageS(e) {
      // console.log(e)
      // alert(111)
      // this.query.pageSize = this.pageSize
      // this.query.pageNum = pageSize

      this.currentPage = e
      this.search()

    },
    nowTime() {
      // 获取当前时间戳
      let data = new Date()
      // 获取年份
      let y = data.getFullYear()
      // 获取月份(注意月份要+1才是现实月份,data.getMonth()返回的值是0~11)
      let mm = data.getMonth() + 1
      if (mm < 10) {
        mm = "0" + mm
      }
      // 获取日期
      let d = data.getDate()
      if (d < 10) {
        d = "0" + d
      }
      // 获取小时
      let h = data.getHours()
      if (h < 10) {
        h = "0" + h
      }
      // 获取分钟
      let m = data.getMinutes()
      if (m < 10) {
        m = "0" + m
      }
      // 获取秒数
      let s = data.getSeconds()
      if (s < 10) {
        s = "0" + s
      }
      // 给p标签里添加内容,显示当前具体时间
      this.nowTimeT = `${y}年${mm}月${d}日${h}时${m}分${s}秒`
    },
    exportDataH() {
      let q = {};
      q.order = this.order;
      q.query = this.query;
      let qq = this.query || {};
      for (const key in qq) {
        if (Object.hasOwnProperty.call(qq, key)) {
          const element = qq[key];
          if (element) {
            q[key] = element;
          }
        }
      }
      this.$Message.info("数据正在导出，请稍后");
      $utils.api
        .load(`/admin/system/nursing/export`, q, "GET")
        .then((res) => {
          if (res) {
            this.urldata = res.msg;
            window.location.href =
              config.API_HOST +
              `/admin/common/download?fileName=${this.urldata}`;
          }
        })
        .catch((err) => {
          $utils.loading.hide();
        });
    },
    async search() {
      let q = this.query
      q.pageNum = this.currentPage
      q.pageSize = this.pageSize
      let res = await $utils.api.load(`/admin/system/nursing/list`, q, "get")
      this.data2 = res.rows
      this.total = res.total
      for (let i = 0; i < this.data2.length; i++) {
        if (this.data2[i].state == 1) {
          this.data2[i].cellClassName = { orderReceivingTime: "demo-table-info-cell-orderReceivingTime" }
        }
        else if (this.data2[i].state == 2) {
          this.data2[i].cellClassName = {
            orderTransferTime: "demo-table-info-cell-orderReceivingTime",
          }
        } else if (this.data2[i].state == 5) {
          this.data2[i].cellClassName = {
            deliveryPatientTime: "demo-table-info-cell-orderReceivingTime",
          }
        }
        else if (this.data2[i].state == 3) {
          this.data2[i].cellClassName = {
            orderFinishTime: "demo-table-info-cell-orderReceivingTime",
          }
        }
        else if (this.data2[i].state == 4) {
          this.data2[i].cellClassName = {
            orderBackTime: "demo-table-info-cell-orderReceivingTime",
          }
        }
      }
    },
    before() {
      this.query.begin = null
      this.query.end = null
      this.search()
    },
    nowData() {
      this.query.begin = new Date().toLocaleDateString()
      this.query.end = new Date().toLocaleDateString()
      this.search()
    },
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/nursing/template/download`;
    },
    initDatas() {
      // 加载详情数据
      $utils.api.load(`/admin/system/nursing/nursingCount`, {}).then((res) => {
        if (res) {

          this.title =
            "预计今日手术人数:" + res.data.today + "人"
          // +
          // "\xa0\xa0\xa0\xa0\xa0\xa0\xa0" +"已进入手术间:" +
          // 4 +"人"+
          // "\xa0\xa0\xa0\xa0\xa0\xa0\xa0" +
          // "历史进入手术间人次:" +
          // 158+"人/次";
          this.titleSecond =
            "已进入手术间:" +
            res.data.enter + "人" +
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0" +
            "历史进入手术间人次:" +
            res.data.all + "人/次";
        }
      });
    },
    toDelete(row) {
      let id = row.id
      $utils.api.load(`/admin/system/nursing/del/${id}`, {}, 'delete').then((res) => {
        if (res) {
          $utils.toast.success("删除成功");
          setTimeout(() => {
            this.search()
          }, 1000);
        }
      })

    },
    toAddPatient() {
      $utils.url.push({
        name: "Patient_add",
        query: { action: "add", msgkv: "add" },
      });
    },
    toAdd(row) {
      $utils.url.push({
        name: "PatientWork_add",
        query: { action: "add", kv: row.id },
      });
    },
    toEdit(row) {
      $utils.url.push({
        name: "Patient_add",
        query: { action: "edit", kv: row.id },
      });
    },
    //详情
    toInfo(row) {
      $utils.url.push({
        name: "PatientWork_info",
        query: { action: "edit", kv: row.id, id: row.id },
      });
    },

  },
};
</script>
<style>
.timeClass {
  margin-top: -50px;
  text-align: right;
}

.ivu-table .demo-table-info-cell-orderReceivingTime {
  background-color: #2668ec;
  color: #fff;
}
</style>
